$(document).ready(function() {

    //$(window).width();   // returns width of browser viewport
    //$(document).width(); // returns width of HTML document

    $('aside.links-aside').on('click', 'a', function(){
        $('aside.links-aside a').css('text-decoration', 'none');
        $(this).css('text-decoration', 'underline');
    });

    if ($(window).width() >= 768) {
        equalize();

        $upcomingCourses = $('#upcoming-courses');
        $quickLinks = $('#quick-links');
        $testimonials = $('#testimonials');
        $videos = $('#videos');

        var padding = 62;

        var upcomingCoursesHeight = $upcomingCourses.height();
        var quickLinksHeight = $quickLinks.height();
        var testimonialsHeight = $testimonials.height();
        var combinedHeight = parseInt(quickLinksHeight) + parseInt(testimonialsHeight);

        if (upcomingCoursesHeight > combinedHeight) {
            $videos.height((upcomingCoursesHeight - quickLinksHeight) - padding);
            equalize();
        } else {
            $upcomingCourses.height(combinedHeight + padding);
        }
    }

    $('footer#site-footer form').on('submit', function(e){
        $('div#processing-message').removeClass('hide');

        e.preventDefault();

        $.ajax({
            method: "POST",
            url: ajax.mailing_list.url,
            data: {
                form: {
                    name: $('#form_name').val(),
                    email: $('#form_email').val(),
                    _token: $('#form__token').val()
                }
            }
        }).done(function(obj) {
            console.log(obj);
            $('div#processing-message').addClass('hide');

            if (obj.status == 'success') {
                $('form#mailing-list').remove();
                $('div#mailing-list-container').html(obj.message);
            } else {
                $('div#mailing-list-container div#error-message').html(obj.message).removeClass('hide');
            }
        });

    });

    $('[data-toggle="offcanvas"]').click(function () {
        $('.row-offcanvas').toggleClass('active')
    });

    function equalize()
    {
        var maxh = 0;
        var $equalizer = $('.equalizer');

        $.each($equalizer, function() {
            maxh = 0;
            $.each($(this).find('.equalizer-watch'), function() {
                if ($(this).height() > maxh) {
                    maxh = $(this).height();
                }
            });
            $.each($(this).find('.equalizer-watch'), function() {
                $(this).height(maxh);
            });
        });
    }

});